import React, { FormEvent, useEffect, useState } from "react";
import { ISection } from "../../../../types/section";
import useUpdateSection from "../../../../hooks/section/useUpdateSection";
import useCreateSection from "../../../../hooks/section/useCreateSection";
import useDeleteSection from "../../../../hooks/section/useDeleteSection";
import { ICriteriaGroup } from "../../../../types/criteriaGroup";
import { useQuestionnaireData } from "../../../../providers/QuestionnaireProvider";
interface ISectionProps {
  sections: ISection[];
  currOption: number[];
  setCurrOption: React.Dispatch<React.SetStateAction<number[]>>;
  isDelete: boolean;
  setIsDelete: React.Dispatch<React.SetStateAction<boolean>>;
  setIsOpenDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  criteriaGroups: ICriteriaGroup[];
}
const Section = ({
  sections,
  currOption,
  setCurrOption,
  isDelete,
  setIsDelete,
  setIsOpenDeleteModal,
  criteriaGroups,
}: ISectionProps) => {
  //eslint-disable-line
  const { questionnaireData } = useQuestionnaireData();
  const sectionId = currOption[0] || 0;
  const [section, setSection] = useState(sections[0]);
  const [title, setTitle] = useState<string>("");

  const [isProcessRunning, setIsProcessRunning] = useState<boolean>(false);
  const [isServiceError, setIsServiceError] = useState<string | null>(null); //eslint-disable-line

  const blankSection: ISection = {
    order: 1,
    questionnaire_id: questionnaireData?.id || 0,
    title: "",
    help: "",
    criteria_group_id: undefined,
    pages: [],
  };

  useEffect(() => {
    if (sectionId === sections.length) {
      setSection({ ...blankSection });
      setTitle("New section");
    } else {
      setSection(sections[sectionId]);
      setTitle(sections[sectionId].title);
    }
  }, [sectionId, sections]); //eslint-disable-line

  const { mutate: updateSection } = useUpdateSection({
    setIsProcessRunning,
    setIsServiceError,
  });
  const { mutate: createSection } = useCreateSection({
    setIsProcessRunning,
    setIsServiceError,
  });
  const { mutate: deleteSection } = useDeleteSection({
    setIsProcessRunning,
    setIsServiceError,
  });

  useEffect(() => {
    if (isDelete) {
      setCurrOption([0]);
      if (section.id) deleteSection(section.id);
      setIsDelete(false);
    }
  }, [isDelete]); //eslint-disable-line

  if (!section) {
    return <p>Loading...</p>;
  }

  const handleSave = (e: FormEvent) => {
    e.preventDefault();

    if (sectionId === sections.length) {
      createSection({
        title: section.title,
        help: section.help,
        criteriaGroupId: section.criteria_group_id,
        questionnaireId: questionnaireData?.id || undefined,
      });
    } else {
      updateSection({
        title: section.title,
        help: section.help,
        id: section.id,
        criteriaGroupId: section.criteria_group_id,
      });
    }
    setTitle(section.title);
  };

  const handleDelete = () => {
    if (sectionId === sections.length) {
      setCurrOption([0]);
      setSection(sections[sectionId]);
    } else {
      setIsOpenDeleteModal(true);
    }
  };

  return (
    <div className="imm_quest_admin__content">
      <div className="content_head">
        <h3>{title}</h3>
      </div>

      <form onSubmit={handleSave} className="content_form">
        <div className="field">
          <label htmlFor="title">Title</label>
          <input
            id="title"
            name="title"
            placeholder="Enter title"
            value={section.title}
            onChange={(e) => setSection({ ...section, title: e.target.value })}
          />
        </div>

        <div className="field">
          <label htmlFor="help">Help</label>
          <input
            id="help"
            name="help"
            placeholder="Enter help"
            value={section.help}
            onChange={(e) => setSection({ ...section, help: e.target.value })}
          />
        </div>

        {criteriaGroups && criteriaGroups.length > 0 && (
          <div className="field">
            <label htmlFor="criteriaGroup">Criteria Group</label>
            <select
              id="criteriaGroup"
              name="criteriaGroup"
              value={section.criteria_group_id || ""}
              onChange={(e) =>
                setSection({
                  ...section,
                  criteria_group_id: parseInt(e.target.value),
                })
              }
            >
              <option value={""}>-- Select criteria group --</option>
              {criteriaGroups.map((criteriaGroup) => (
                <option key={criteriaGroup.id} value={criteriaGroup.id}>
                  {criteriaGroup.title}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="actions">
          <button className="delete_btn" type="button" onClick={handleDelete}>
            {isProcessRunning ? (
              <i className="imm_quest_admin__process_loader" />
            ) : sectionId === sections.length ? (
              "Cancel"
            ) : (
              "Delete"
            )}
          </button>
          <button className="save_btn" type="submit">
            {isProcessRunning ? (
              <i className="imm_quest_admin__process_loader" />
            ) : sectionId === sections.length ? (
              "Create"
            ) : (
              "Save"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Section;
